import React from 'react'

export default function FooterIDMS() {

  return (
    <footer className="">
      <div id = "cssmenu_bottom" className="navbar-bottom" >

          <a href="#learn">Learn</a> 
          <a href="#news">News</a>
          <a href="#feedback">feedback</a>
          <a href="#contact">@English (US)</a>  

          
          <p  id= "copyright" className = "" >@2023 - 2026 iDMS Investment .Inc or its affiliate. All rights reserved</p> 

    </div> 
    </footer>

  )
}
